<template>
    <div>
        <div>
            <h2>{{$t('intern_rechnung_bezahlen.rechnung_title')}}</h2>

          <span>{{$t('intern_rechnung_bezahlen.rechnung_nr')}}</span> &#160; <span>{{this.invoice.rechnungsnummer}}</span>
            <br /><br />

          <span> {{$t('intern_rechnung_bezahlen.rechnung_betrag')}} </span> &#160; <span>{{this.invoice.total_brutto | currency}}</span>
            <br /><br />
        </div>
        <div v-if="invoice.status = 'bezahlt'">
            <span>{{$t('intern_rechnung_bezahlen.zahlung_erfolg')}}</span>
        </div>

        <div class="mt-3">
            <router-link :to="{name: 'inserat-uebersicht', params: {page: this.$store.state.lastOpenedPage}}" :exact="true" class="btn btn-success float-right">Zurück zur Übersicht</router-link>
        </div>
    </div>
</template>

<script>

    export default {
        data() {
            return {
              invoice : []
            }
        },
        props: ['invoice_id'],
        methods: {
            scrollTop() {
                window.scrollTo(0, 0);
            }
        },
        created() {
            document.title = 'Rechnung bezahlen';
            this.scrollTop();
            this.$store.state.loading = true;
            this.$http.get('invoiceApi/getInvoice?invoice_id=' + this.invoice_id).then(response => {
               const data = JSON.parse(response.data);
               this.invoice =  data.invoice;
            }).catch( error => {
                console.log(error);
            }).then(() => {
                this.$store.state.loading = false;
            });
        }
    }
</script>

<style scoped>
.paymentWindow{
    width: 100%;
    height: 700px;
    border: none;
}
</style>
